
import { Options, Vue } from 'vue-class-component';
import api from '@/shared/api';
import getAppDefinitions, { AppDefinitions } from '@/shared/apps';
import { nextTick } from 'vue';

@Options({})
export default class AppExternalLauncher extends Vue {
    protected loading = true;
    protected error = '';
    protected iframeName = 'external-app-iframe';
    protected appTitle = 'External App';
    protected appDefinitions: AppDefinitions = {};

    async mounted() {
        try {
            const appId = parseInt(this.$route.params.appId as string);
            this.appDefinitions = await getAppDefinitions();
            const app = await api.getAppSettings(appId);
            this.appTitle = this.appDefinitions[app.app_name]?.title || app.app_name || this.appTitle;

            const response = await api.getExternalAppBootstrap(appId);
            this.loading = false;
            await nextTick();
            this.submitBootstrapForm(response);
        } catch (e) {
            console.error(e);
            this.error = 'Unable to launch this app. Please try again.';
            this.loading = false;
        }
    }

    submitBootstrapForm(payload: any) {
        const method = payload?.form?.method || 'POST';
        const action = payload?.targetUrl;
        const fields = payload?.form?.fields || {};

        if (!action) {
            throw new Error('Invalid bootstrap payload');
        }

        const form = document.createElement('form');
        form.method = method;
        form.action = action;
        form.target = this.iframeName;
        form.style.display = 'none';

        for (const key in fields) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = fields[key];
            form.appendChild(input);
        }

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }
}
